import FpDynamicParameter from './FpDynamicParameter.jsx'
export default FpDynamicParameter
